<script>
    import TableData from './TableData.svelte';

    export let engagementCount;
    export let activityNamePlural;
    export let activityNamePastEngagement;
    export let tooltipId;

    let engagementIcon;
    let engagementTooltip;
    let engagementIconClass;

    $: {
        if (engagementCount == 0) {
            engagementIcon = 'x-circle-fill';
            engagementIconClass = 'text-danger';
            engagementTooltip = `No ${activityNamePlural}`;
        } else if (engagementCount == 1) {
            engagementIcon = '1-circle-fill';
            engagementIconClass = 'text-warning';
            engagementTooltip = `${activityNamePastEngagement} on 1 day`;
        } else {
            engagementIcon = 'check-circle-fill';
            engagementIconClass = 'text-success';
            engagementTooltip = `${activityNamePastEngagement} on ${engagementCount} days`;
        }
    }
</script>

<TableData icon={engagementIcon} iconSize={'lg'} classes={engagementIconClass}
    {tooltipId} tooltipText={engagementTooltip} />